import { Component, Input, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { anyUserProfile, removeNulls } from '@thehubz/client/core';
import { User, Vacation } from '@thehubz/client/data-access-api';
import { BehaviorSubject, filter } from 'rxjs';
import { UserProfileService } from '../user-profile.service';

@Component({
  selector: 'thehubz-user-vacations',
  templateUrl: './user-vacations.component.html',
  styleUrls: ['./user-vacations.component.scss'],
})
export class UserVacationsComponent {
  @Input() set userData(userData: User) {
    if (!userData) {
      return;
    }
    this._userData = userData;
    this._vacations$.next(userData.profile.vacations || []);
  }
  get userData(): User {
    return this._userData;
  }
  private _userData!: User;

  @Input() isOtherUser = false;
  @Input() userId?: string;

  AnyUserProfile = anyUserProfile;

  /**
   * Vacations data behavior subject
   */
  private _vacations$ = new BehaviorSubject<Vacation[]>([]);
  vacations$ = this._vacations$.asObservable().pipe(filter(removeNulls));

  /* columns to display in table */
  // columnsToDisplay: string[] = [' ', 'From', 'To', 'Recurrence', 'addVacation'];
  @ViewChild(MatSort) sort: MatSort;

  vacations: MatTableDataSource<Vacation>;

  constructor(private userProfileService: UserProfileService) {
    this.sort = new MatSort();
    this.vacations = new MatTableDataSource<Vacation>();
  }

  vacationDialog(vacation?: Vacation, index = -1) {
    if (this.userId) {
      this.userProfileService.openVacationDialog(this.userId, this._vacations$.value, this.userData, vacation, index);
    }
  }

  deleteDialog(index: number) {
    if (this.userId) {
      this.userProfileService.deleteVacation(index, this.userId, this._vacations$.value, this.userData);
    }
  }
}
